export default "__VITE_ASSET__D_sk9i$q__"